import React, { Component } from "react";
import { readStorageJSON, project, format_date, toFixed, replaceTextHTML, loading, GET } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/pdf.css";
function parsePythonDictOrJson(str) {
  if (typeof str !== 'string') return str;
  // ค่าเสียแปลงไม่ได้ = null (caller ใช้ค่า default ของหน้าแทน) ห้าม throw
  const asObject = (v) => (v !== null && typeof v === 'object' ? v : null);
  try {
    return asObject(JSON.parse(str));
  } catch (_) {
    try {
      const json = str
        .replace(/True/g, 'true')
        .replace(/False/g, 'false')
        .replace(/None/g, 'null')
        .replace(/'/g, '"');
      return asObject(JSON.parse(json));
    } catch (__) {
      return null;
    }
  }
}

const size = {
  A4: { width: 1116, height: 789 },
  A5: { width: 1116, height: 792, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 685, zoom: 0.385 },
  "9 x 11 นิ้ว": { width: 1116, height: 685, zoom: 0.77 },
  "9 x 5.5 นิ้ว": { width: 1116, height: 685, zoom: 0.77 },
};
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      setting: {
        size: "", // A4, A5, 4.5 x 5.5 นิ้ว, 9 x 11 นิ้ว, 9 x 5.5 นิ้ว
        header_1: { status: true, title: "-โลโก้" },
        header_2: { status: true, title: "" }, // โครงการ
        header_3: { status: true, title: "" }, // ที่อยู่
        header_4: { status: true, title: "-ใบแจ้งหนี้ค่าน้ำ/ค่าใช้จ่ายส่วนกลาง" },
        header_5: { status: true, title: "-เลขที่ใบแจ้งหนี้" },
        header_6: { status: true, title: "-วันที่แจ้งหนี้" },
        header_7: { status: true, title: "-ชื่อ-นามสกุล" },

        th_1: { status: true, title: "-เลขมาตร เดือนนี้" },
        th_2: { status: true, title: "-เลขมาตร เดือนก่อน" },
        th_3: { status: true, title: "-หน่วยที่ใช้" },
        th_4: { status: true, title: "-ค่าน้ำประปา" },
        th_5: { status: true, title: "-ค่าบริการอุปกรณ์" },
        th_6: { status: true, title: "-ค่าขยะ" },
        th_7: { status: true, title: "-ค่าส่วนกลาง" },
        th_8: { status: true, title: "-ค่าเบี้ยประกัน" },
        th_9: { status: true, title: "-ค่าเคเบิล" },
        th_10: { status: true, title: "-เพิ่ม/ลดหนี้" },
        th_11: { status: true, title: "-ค่าต่อมิเตอร์" },
        th_12: { status: true, title: "-เบี้ยปรับ" },
        th_13: { status: true, title: "-ค่าใช้จ่ายปัจจุบัน" },
        th_14: { status: true, title: "-งวดค้าง" },
        th_15: { status: true, title: "-จำนวนเงินค้างชำระ" },

        tr_1: { status: true, title: "-ข้อมูลในตาราง" },

        footer_1: { status: true, title: "-รวมเป็นเงิน" },
        footer_2: { status: true, title: "" }, // อัตราจัดเก็บค่าน้ำ
        footer_3: { status: true, title: "" }, // หมายเหตุ
        footer_4: { status: true, title: "" }, // ข้อความเตือน 1
        footer_5: { status: true, title: "" }, // ข้อความเตือน 2
        footer_6: { status: true, title: "" }, // ข้อความเตือน 3
        footer_7: { status: true, title: "" }, // QRCode ไลน์
        footer_8: { status: true, title: "" }, // QRCode บัญชี
        footer_9: { status: true, title: "" }, // ชื่อบัญชี
      },
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
    this.setState({ data: readStorageJSON("DATA_") });
    const setting = Object.entries(this.state.setting);
    for (let item of setting) {
      if (!item[1].status) {
        try {
          let component = document.getElementsByClassName(item[0]);
          for (let co of component) {
            co.classList.add("d-none");
          }
        } catch (e) {}
      }
    }

    if (!this.state.setting.header_1.status && !this.state.setting.header_2.status && !this.state.setting.header_3.status && !this.state.setting.header_5.status && !this.state.setting.header_6.status) {
      document.getElementsByClassName("header_1_2_3_4_5_6")[0].classList.add("d-none");
      document.getElementsByClassName("header_1_2_3_4_5_6")[1].classList.add("d-none");
    }
    await replaceTextHTML();
    setTimeout(()=>{
      window.print();
    },1000)
  }
  Get = async () => {
    const settings = readStorageJSON("cds-setting") || {};
    if (settings?.setting_document_custom?.[0]?.invoice_by_room) {
      const invoice_by_room = settings.setting_document_custom[0].invoice_by_room;
      this.setState({ setting: (typeof invoice_by_room === 'string' ? parsePythonDictOrJson(invoice_by_room) : invoice_by_room) || this.state.setting });
    }
    // ดึงข้อมูลโครงการ (รวมรูปหัวกระดาษ) สดจาก API แทนการเชื่อ localStorage ที่อาจเก่ากว่าข้อมูลจริงใน DB
    if (project?.project_id) {
      const fresh = await GET("api/public/project", { project_id: project.project_id });
      if (fresh?.status && fresh.data) {
        this.setState({ picture_paper: fresh.data.picture_paper || "" });
      }
    }
    this.setState({ loading: false });
  };
  render() {
    return (
      <div className="w-100">
        {!this.state.loading && (
          <div>
            {this.state.data.map((item, index) => (
              <div className={"mx-auto bg-white border-bottom " + (this.state.setting.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf")} 
          style={{
            ...size[this.state.setting?.size || "A4"],
            paddingLeft: Number(this.state.setting?.paddingLeft),
            paddingRight: Number(this.state.setting?.paddingRight),
            paddingTop: Number(this.state.setting?.paddingTop),
            paddingBottom: Number(this.state.setting?.paddingBottom),
        }}>
                <table className="table table-bordered mb-0 header">
                  <tr className="header_1_2_3_4_5_6">
                    <td rowSpan={2} className="border-bottom-0">
                      <div className="d-flex align-items-center">
                        <img src={this.state.picture_paper || project["picture_paper"] || LOGO} style={{ width: 100, height: 100, objectFit: "contain", marginRight: 6 }} alt="LOGO" className="bg-contain header_1" />
                        <div>
                          <h2 className="fw-bold header_2 px-2 mb-0">{this.state.setting.header_2?.title || ""}</h2>
                          <div className="header_3 px-2">{this.state.setting.header_3?.title.split("\n").map(e=>(<div>{e}</div>)) || ""}</div>
                        </div>
                      </div>
                    </td>
                    <td className="wpx-250 text-center border-bottom-0 header_4">
                      <h4 className="fw-bold mb-0">ใบแจ้งหนี้ค่าน้ำ/ค่าใช้จ่ายส่วนกลาง</h4>
                    </td>
                  </tr>
                  <tr className="header_1_2_3_4_5_6">
                    <td className="border-bottom-0 wpx-250">
                      <div className="header_5">เลขที่ใบแจ้งหนี้ : {format_date(item.datetime_create, "yymm") + "-" + item.address_number}</div>
                      <div className="header_6">วันที่แจ้งหนี้ : {format_date(new Date(), "dd mmmm yyyy")}</div>
                    </td>
                  </tr>
                  <tr className="header_7">
                    <td className="border-bottom-0" colSpan={2}>
                    <h4 className="fw-bold mb-0">ชื่อ-นามสกุล : {item.full_name + " อาคารเลขที่ " + item.building + " ห้องเลขที่ " + (item.address ? item.address : item.address_number) }</h4>
                    </td>
                  </tr>
                </table>
                <table className="table table-bordered mb-0">
                  <tr>
                    <td className="py-1 th_1 text-center">เลขมาตร {format_date(new Date(new Date(new Date(item.datetime_create).setDate(1)).setMonth(new Date(item.datetime_create).getMonth())), "mmm")}</td>
                    <td className="py-1 th_2 text-center">เลขมาตร {format_date(new Date(new Date(new Date(item.datetime_create).setDate(1)).setMonth(new Date(item.datetime_create).getMonth()-1)), "mmm")}</td>
                    <td className="py-1 th_3 text-center">หน่วยที่ใช้</td>
                    <td className="py-1 th_4 text-center">ค่าน้ำประปา {format_date(new Date(new Date(new Date(item.datetime_create).setDate(1)).setMonth(new Date(item.datetime_create).getMonth())), "mmm yy","th")}</td>
                    <td className="py-1 th_5 text-center">ค่าบริการอุปกรณ์ {format_date(new Date(new Date(new Date(item.datetime_create).setDate(1)).setMonth(new Date(item.datetime_create).getMonth())), "mmm yy","th")}</td>
                    <td className="py-1 th_6 text-center">ค่าขยะ {format_date(new Date(new Date(new Date(item.datetime_create).setDate(1)).setMonth(new Date(item.datetime_create).getMonth())), "mmm yy","th")}</td>
                    <td className="py-1 th_7 text-center">ค่าส่วนกลาง {format_date(new Date(new Date(item.datetime_create).setMonth(new Date(item.datetime_create).getMonth()+1)), "mmm yy", "th")}</td>
                    <td className="py-1 th_8 text-center">ค่าเบี้ยประกัน</td>
                    <td className="py-1 th_9 text-center">ค่าเคเบิล</td>
                    <td className="py-1 th_10 text-center">เพิ่ม/ลดหนี้</td>
                    <td className="py-1 th_11 text-center">ค่าต่อมิเตอร์</td>
                    <td className="py-1 th_12 text-center">เบี้ยปรับ</td>
                    <td className="py-1 th_13 text-center">ค่าใช้จ่ายปัจจุบัน</td>
                    <td className="py-1 th_14 text-center">งวดค้าง</td>
                    <td className="py-1 th_15 text-center">จำนวนเงินค้างชำระ</td>
                  </tr>
                  <tr className="tr_1">
                    <td className="py-1 th_1 text-center">{item.current_gauge_number}</td>
                    <td className="py-1 th_2 text-center">{item.last_gauge_number}</td>
                    <td className="py-1 th_3 text-center">{item.unit_used}</td>
                    <td className="py-1 th_4 text-right">{toFixed(item.water_bill)}</td>
                    <td className="py-1 th_5 text-right">{toFixed(item.equipment_maintenance_fee)}</td>
                    <td className="py-1 th_6 text-right">{toFixed(item.waste_cost)}</td>
                    <td className="py-1 th_7 text-right">{toFixed(item.common_expenses)}</td>
                    <td className="py-1 th_8 text-right">{toFixed(item.fire_cost)}</td>
                    <td className="py-1 th_9 text-right">{toFixed(item.cable_cost)}</td>
                    <td className="py-1 th_10 text-right">{toFixed(item.other_income +(item.add_debt - item.reduce_debt))}</td>
                    <td className="py-1 th_11 text-right">{toFixed(item.meter_connect_cost)}</td>
                    <td className="py-1 th_12 text-right">{toFixed(item.total_cost_late)}</td>
                    <td className="py-1 th_13 text-center">{item.total_amount ? toFixed(item.total_amount) : "0.00"}</td>
                    <td className="py-1 th_14 text-right">{item.count_installment ? item.count_installment - 1 : 0}</td>
                    <td className="py-1 th_15 text-right">{item.overdue_amount ? toFixed(item.overdue_amount) : "0.00"}</td>
                  </tr>
                </table>
                <table className="table table-bordered mb-0 footer_2">
                  <tr>
                    <td className="border-top-0 text-right">
                      <div className="d-flex justify-content-end">
                      <h3 className="fw-bold d-flex mb-0">รวมทุกรายการเป็นเงินทั้งสิ้น {toFixed(item.total_amount + item.overdue_amount)} บาท</h3>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1 border-top-0 text-center">{this.state.setting?.footer_2.title}</td>
                  </tr>
                </table>
                <div className="footer_3 mb-5 mt-2">{this.state.setting.footer_3?.title.split("\n").map(e=>(<div>{e}</div>)) || ""}</div>

                <div className="d-flex w-100">
                  <div className="w-100">
                    <div className="footer_4 fw-bold text-danger text-30 mb-4">{this.state.setting?.footer_4.title}</div>
                    <div className="footer_5 fw-bold text-danger text-30 mb-4">{this.state.setting?.footer_5.title}</div>
                    <div className="footer_6 fw-bold text-primary text-30">{this.state.setting?.footer_6.title}</div>
                  </div>
                  <div className="wpx-350 text-center">
                    <div className="w-100 d-flex justify-content-center mb-3">
                      {this.state.setting?.footer_7.title && <img src={"data:image/png;base64," + this.state.setting?.footer_7.title} style={{ width: 150, height: 150, objectFit: "contain", marginRight: 6 }} alt="LOGO" className="bg-contain mx-2 footer_7" />}
                      {this.state.setting?.footer_8.title && <img src={"data:image/png;base64," + this.state.setting?.footer_8.title} style={{ width: 150, height: 150, objectFit: "contain", marginRight: 6 }} alt="LOGO" className="bg-contain mx-2 footer_8" />}
                    </div>
                    <div className="footer_9 text-center w-100">{this.state.setting?.footer_9.title}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}
